<template>
    <div class="rcclConfirm" :style="show()">
        <div id="popup_overlay"></div>
        <div id="popup_container">
            <div id="popup_title">
                <div class="title_logo"></div>
            </div>
            <div id="popup_content" class="confirm">
                <div id="popup_message" v-html="text"></div>
                <div id="popup_panel">
                    <a id="popup_ok" @click="confirmClick">{{buttons[1]}}</a>
                    <a id="popup_cancel" @click="cancelClick">{{buttons[0]}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RcclConfirm',
    data () {
        return  {
            title: '温馨提示',
            text: '',
            buttons: ['取消', '确定'],
            isShow: false
        }
    },
    confirmCallBack () {
    },
    cancelCallBack () {

    },
    methods: {
        confirmClick () {
            this.isShow = false
            if (this.confirmCallBack) {
                this.confirmCallBack()
            }
        },
        cancelClick() {
            this.isShow = false
            if (this.cancelCallBack) {
                this.cancelCallBack()
            }
        },
        show() {
            return this.isShow ? { 'display': 'block'} : { 'display': 'none' }
        }
    }
}
</script>

<style lang="less" scoped>
    #popup_overlay {
        position: fixed;
        z-index: 99998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgb(102, 102, 102);
        opacity: 0.5;
    }
    #popup_container {
        position: fixed;
        z-index: 99999;
        padding: 0;
        margin: 0;
        min-width: 380px;
        max-width: 380px;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
</style>
